export default "__VITE_ASSET__Ds1_kkdM__"